module.exports = __webpack_public_path__ + "static/dashboard-c17eb61d0c51b4496712b2d8fd45489e.png";